export default __webpack_public_path__ + "static/media/ejjadh-logo.d337029d.svg";